module.exports = __webpack_public_path__ + "static/varre1-c00aaea16d48d4f33bf453477fc858ce.jpg";